import { Select } from "@win-reality/react-ui";
import { useMemo } from "react";

import type { MachineOwnerOrg } from "@/hooks/useOwnerOrgsFromMachine";

type MachineOrganizationSelectProps = {
  orgs: MachineOwnerOrg[];
  value: string | null;
  onChange: (orgId: string) => void;
  isLoading?: boolean;
  isInvalid?: boolean;
};

function MachineOrganizationSelect({
  orgs,
  value,
  onChange,
  isLoading = false,
  isInvalid = false,
}: MachineOrganizationSelectProps) {
  const items = useMemo(
    () => orgs.map((o) => ({ label: o.orgName, value: o.orgId })),
    [orgs],
  );

  const placeholder = useMemo(() => {
    if (isLoading) return "Loading organizations…";
    if (orgs.length === 0) return "No organizations available";
    return "Choose an organization";
  }, [isLoading, orgs.length]);

  return (
    <Select
      items={items}
      value={value || undefined}
      onValueChange={onChange}
      placeholder={placeholder}
      isDisabled={isLoading || orgs.length === 0}
      isInvalid={isInvalid}
    />
  );
}

export { MachineOrganizationSelect };
